var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgConnect(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 125,
    viewBox: "0 0 18 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17a.5.5 0 00-1 0h1zm-1 90a.5.5 0 001 0h-1zm0-84.375a.5.5 0 001 0h-1zm1 11.25a.5.5 0 00-1 0h1zm-1 11.25a.5.5 0 001 0h-1zm1 11.25a.5.5 0 00-1 0h1zm-1 11.25a.5.5 0 001 0h-1zm1 11.25a.5.5 0 00-1 0h1zm-1 11.25a.5.5 0 001 0h-1zm1 11.25a.5.5 0 00-1 0h1zM8.5 17v5.625h1V17h-1zm0 16.875v11.25h1v-11.25h-1zm0 22.5V62h1v-5.625h-1zM8.5 62v5.625h1V62h-1zm0 16.875v11.25h1v-11.25h-1zm0 22.5V107h1v-5.625h-1z",
    fill: "#67466C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    stroke: "#67466C",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 116,
    r: 8,
    stroke: "#67466C",
    strokeWidth: 2
  })));
}
export default SvgConnect;